import React from 'react';
import PropTypes from 'prop-types';
import './LockScreen.css';
import {Modal} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { AuthInfo } from "../../App";
import { Logout,host,Authenticate } from "../../utils";
import { useContext,useState,useEffect } from "react";
import axios from "axios";

function LockScreen(props) {
    const [username,setUsername] = useState(props.username);
    const [password,setPassword] = useState(props.password);
    const [show,setShow] = useState(true);

    const validateLogin = async () => {
      let res = await Authenticate(username,password);
      if(res){
          props.setShow(false);
      }
    }

        return (
          <Modal id="jobStart" show={props.show}>
              <Modal.Header>
                  <h4 className="modal-title">Login</h4>
              </Modal.Header>
              <Modal.Body>
                  <div className="login-modal">
                      <p className="text-center">
                          <span className="roundedIcon">
                              <FontAwesomeIcon icon={faLock}/>
                          </span>
                      </p>
                      <div className="form-group">
                          <input type="text" className="form-control"  placeholder="Email" defaultValue={props.username?props.username:""} disabled={!(props.username==undefined)} onChange={(e)=>{setUsername(e.target.value)}}/>
                      </div>
                      <div className="form-group">
                          <input type="password" className="form-control" placeholder="Password" onChange={(e)=>{setPassword(e.target.value)}}/>
                      </div>
                  </div>
              </Modal.Body>
              <Modal.Footer className="justify-content-center">
                  <div className="row">
                      <div className="col-12">
                          <button className="btn btn-default" data-dismiss="modal" onClick={Logout}>Logout</button>&nbsp;&nbsp;&nbsp;&nbsp;
                          <a href="#" className="btn btn-primary" onClick={validateLogin}>Login</a>
                      </div>
                  </div>
              </Modal.Footer>
          </Modal>
        )
    }


LockScreen.propTypes = {};

LockScreen.defaultProps = {};

export default LockScreen;
